/**
 * Ends this account's sessions on every *other* device.
 *
 * Its own module, with no dependency on `window` or better-auth's client, so it is testable
 * without a DOM — `api/auth.ts` cannot be imported outside a browser at all, because
 * `createAuthClient` reads `window.location` at import time.
 *
 * "Others" rather than "all": this request's own session has to survive long enough to answer it.
 * The caller's cookie dies a moment later, when `logout()` runs better-auth's sign-out.
 */
export async function revokeOtherSessions(fetchImpl: typeof fetch = fetch): Promise<number> {
  const res = await fetchImpl('/api/me/sessions/revoke-others', {
    method: 'POST',
    credentials: 'include',
  })
  if (!res.ok) return 0
  const body = (await res.json()) as { revoked?: number }
  return body.revoked ?? 0
}
